import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import PropTypes from "prop-types";

import { PrivateRoute } from "./privateRoute";
import Forbidden from "../components/pages/403";
import EnergyCostCalculator from "../containers/energyCostCalculator";
import KooeeBenefitsWall from "../containers/kooeeBenefitsWall";
import NrgPackages from "../containers/nrgPackages";
import HeaderMenu from "../components/ui-elements/header";
import SelectPackage from "../containers/selectPackage";

class MainRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: window.location.pathname === "/callback"
    };
  }

  render() {
    if (this.state.isLoggedIn && !this.props.isUserfetched) {
      return null;
    }
    return (
      <main>
        <Switch>
          <Route exact path="/energy-cost-cal" header={HeaderMenu} component={EnergyCostCalculator} />
          {/* <PrivateRoute exact path="/benefits-wall" component={KooeeBenefitsWall} /> */}
          <PrivateRoute exact path="/nrg-packages" component={NrgPackages} />
          <PrivateRoute exact path="/select-package" component={SelectPackage} />
          <Route exact path="/" component={EnergyCostCalculator} />
          <Route path="/" component={Forbidden} />
        </Switch>
      </main>
    );
  }
}

MainRoute.propTypes = {
  isUserfetched: PropTypes.bool
};

export default MainRoute;
